import { IMap } from 'src/app/core/models/api';
import { DownloadReportViewModel } from '../models';

export abstract class DownloadReportMapper {
  static mapForDownload(source: IMap, target: DownloadReportViewModel): void {
    target.fiscalCode = source.fiscalCode;
    target.businessName = source.businessName;
    target.contactEmail = source.contactEmail;
    target.contactPhone = source.contactPhone;
    target.localityId = source.localityId;
  }


  static mapForSave(source: DownloadReportViewModel): IMap {
    return {
      fiscalCode: source.fiscalCode,
      businessName: source.businessName,
      contactEmail: source.contactEmail,
      contactPhone: source.contactPhone,
      localityId: source.localityId,
      mapImageBase64: source.mapImageBase64
    } as IMap;
  }
}
